import { Component, Input } from '@angular/core';
import { LogisticCompanyDetails } from '../../../_services/admin-logistic-partner.service';
import { DocumentService } from '../../../_services/document.service';

@Component({
    selector: 'app-logistic-company-detail',
    templateUrl: './logistic-company-detail.component.html',
    styleUrls: ['./logistic-company-detail.component.css'],
    standalone: false
})
export class LogisticCompanyDetailComponent {
    @Input() partner: LogisticCompanyDetails;

    constructor(private documentService: DocumentService) {}

    downloadDocument(documentId: string, documentPath: string): void {
        const fileName = documentPath.split('/').pop() || 'document';

        this.documentService.downloadDocumentAdminById(documentId).subscribe({
            next: (blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            },
            error: () => {
                console.error('Error downloading document');
            }
        });
    }

    getDocumentTypeLabel(documentType: string): string {
        switch (documentType) {
            case 'IdCard':
                return 'ID Card';
            case 'Passport':
                return 'Passport';
            case 'RegistrationCertificate':
                return 'NIU (Numéro d\'Identifiant Unique)';
            case 'TaxComplianceCertificate':
                return 'Tax Compliance Certificate';
            case 'RegistrationOfIncorporation':
                return 'Certificate of Incorporation';
            default:
                return documentType;
        }
    }
}
